import * as moment from 'moment';
import { Config } from '../config';

export function isMoreThan90DaysAhead(date: string): boolean {
  return moment(date).isAfter(moment().add(90, 'days'));
}

export function isBetween30And90DaysAhead(date: string): boolean {
  const targetDate = moment(date);
  return targetDate.isAfter(moment().add(30, 'days')) && targetDate.isBefore(moment().add(90, 'days'));
}

export function isLessThan30DaysAhead(date: string): boolean {
  return moment(date).isBefore(moment().add(30, 'days'));
}

export function isMoreThan12MonthsBehind(date: string): boolean {
  return moment(date).isBefore(moment().subtract(12, 'months'));
}

export function dateWithinDaysWindow(date: string, days: number): boolean {
  return moment().isBefore(moment(date).add(days, 'days'));
}

export function isToday(date: string): boolean {
  return moment().isSame(date, 'day');
}

export function dateAfterDays(date: string, days: number, momentFormat?: string): string {
  return moment(date).add(days, 'days').format(momentFormat);
}
